
import React, { useState, useRef, createRef, useEffect } from "react";

import './../../_css/Leftmenu.css';
import { genURL } from './../../_getjson';
import axios from 'axios'
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { Drawer } from "@mui/material";
import { Hidden } from "@mui/material";
// core components 
import styles from "./../../assets/jss/psstyle/component/slidebarstyle";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

const useTreeItemStyles = makeStyles(styles);

export default function Adminslidbar(props) {
    let ps;
    const classes = useTreeItemStyles()
    const sidebarWrapper = createRef()
    const [loading, setloading] = useState(false);
    const [percentCompleted, setpercentCompleted] = useState(0);

    // const [open, setOpen] = useState(true); 
    // verifies if routeName is the one active (in browser input)
    // function activeRoute(routeName) {
    //   return window.location.href.indexOf(routeName) > -1 ? true : false;
    // }
    const [RightMenu, setRightMenu] = useState()
    const { color, logo, image, logoText, routes,
        // routessub, routesmain, 
        loadding } = props;
    //console.log(routes); 
    useEffect(() => {
        ps = new PerfectScrollbar(sidebarWrapper.current, {
            suppressScrollX: true,
            suppressScrollY: false
            // wheelSpeed: 2,
            // wheelPropagation: true,
            // minScrollbarLength: 20
        });
        return function cleanup() {
            ps.destroy();
            // -------------- get category 
        };
    }, [sidebarWrapper]);
    useEffect(() => {
        OnLoadRightMenu()

    }, [])


    const OnLoadRightMenu = async function () {
        let newurl = genURL("CSRIGHT/MainMenu?user=" + localStorage.getItem('Username'))
        const options = {
            onUploadProgress: (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                // console.log(percentCompleted);
                setpercentCompleted(percentCompleted)
            },
        };
        await axios.get(newurl, options, { timeout: 5000 }).then((res) => {
            setloading(true)
            if (res.data.length > 0) {
                //setlengData(res.data.length)
                // console.log("Data", res.data);
                setRightMenu(res.data)
                OnSeeMenu();
            } else {
                setRightMenu("")
            }
        }).then(_ => {
            // setshowloading(false)
        })
    }
    var links = (
        <div className="_leftmenu">
            <br></br>
            {localStorage.getItem('Token') && RightMenu ?
                RightMenu.map(function (RightMenus, i) { return <ListMenu key={i} Name={RightMenus.MENUNAME} sysCode={RightMenus.MENUID} /> }) : null}
        </div>
    );
    var brand = (
        <div className={classes.logo}>
            <a href="#" className={classNames(classes.logoLink, { [classes.logoLinkRTL]: props.rtlActive })} target="_blank">
                <div className={classes.logoImage}>
                    <img src={logo} alt="logo" className={classes.img} />
                </div>
                {logoText}
            </a>
        </div>
    );
    return (
        <div >
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={props.rtlActive ? "left" : "right"}
                    open={props.open}
                    classes={{
                        paper: classNames(classes.drawerPaper, {
                            [classes.drawerPaperRTL]: props.rtlActive
                        })
                    }}
                    onClose={props.handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile.
                    }}
                >
                    {/* {brand} */}
                    <div className={classes.sidebarWrapper} ref={sidebarWrapper}>
                        {links}

                    </div>
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    anchor={"left"}
                    variant="permanent"
                    open
                    classes={{
                        paper: classNames(classes.drawerPaper, {
                            [classes.drawerPaperRTL]: props.rtlActive
                        })
                    }}
                >
                    {brand}
                    <div className={classes.sidebarWrapper} ref={sidebarWrapper} >
                        {links}
                    </div>
                </Drawer>
            </Hidden>
        </div>
    );
}

Adminslidbar.propTypes = {
    rtlActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
    logo: PropTypes.string,
    image: PropTypes.string,
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool,
    loadding: PropTypes.bool
};

export class ListMenu extends React.Component {
    state = {
        manuName: this.props.Name,
        sysCode: this.props.sysCode,
        RightMenu: []
    }
    componentDidMount() {

        var url = "CSRIGHT/SubMenu?user=" + localStorage.getItem('Username') + "&syscode=" + this.state.sysCode;
        axios.get(genURL(url), { timeout: 4000 }).then(async res => {
            await this.setState({ RightMenu: res.data });
        }).catch(error => {
            console.log(error);
        });
    }
    onActive = (refID) => {
        var aa = localStorage.getItem("Leftmenu");
        if (this.refs[refID].className === "sliDivMenu") {
            this.refs[refID].className = "sliDivMenu active";
            this.refs[refID + "Icon"].className = "far fa-minus-square";
            aa += ("|" + this.state.sysCode);
        } else {
            this.refs[refID].className = "sliDivMenu";
            this.refs[refID + "Icon"].className = "far fa-plus-square";
            aa = aa.split("|" + this.state.sysCode).join("");
        };
        localStorage.setItem("Leftmenu", aa);

    }
    render() {
        var rightmenu = ""
        if (this.state.RightMenu) {
            rightmenu = this.state.RightMenu.map(function (RightMenus, i) { return <SubMenu key={i} Name={RightMenus.MENUNAME} sysCode={RightMenus.MENUID} /> })
        }
        return (
            <div>
                <button className="sliderMenuButton" id={this.state.sysCode} title={this.state.sysCode} onClick={this.onActive.bind(null, "menu1")}>
                    <i ref="menu1Icon" className="far fa-plus-square " ></i>
                    <i className="C_MenuTxt"> {this.state.manuName}</i>
                    <i id={this.state.sysCode + "loading"}></i>
                </button>
                <div className="sliDivMenu" ref="menu1" >
                    {rightmenu}
                </div>
            </div>
        )
    }
}
/*------------------------------------------------------*------------------------------------------------------*/
export class SubMenu extends React.Component {
    state = {
        manuName: this.props.Name,
        sysCode: this.props.sysCode,
        class: "far fa-minus-square",
        RightMenu: []
    }
    onActive = (refID) => {
        console.log("dddddd");
        var aa = localStorage.getItem("Leftmenu");
        console.log(this.refs[refID].className);
        if (this.refs[refID].className === "sliDivMenu2") {
            this.refs[refID].className = "sliDivMenu2 active";
            this.refs[refID + "Icon"].className = "far fa-minus-square ";
            aa += ("|" + this.state.sysCode);
        } else {
            this.refs[refID].className = "sliDivMenu2";
            this.refs[refID + "Icon"].className = "far fa-plus-square";
            aa = aa.split("|" + this.state.sysCode).join("")
        }
        localStorage.setItem("Leftmenu", aa);
    }
    componentDidMount() {
        var url = "CSRIGHT/SubMenu2?user=" + localStorage.getItem('Username') + "&syscode=" + this.state.sysCode;
        for (let i = 0; i <= 1; i++) {
            axios.get(genURL(url), { timeout: 10000 }).then(async res => {
                await this.setState({ RightMenu: res.data });
                if (res.data.length > 0) {
                    this.setState({ class: "far fa-minus-square " })
                }
            }).catch(error => {
                console.log(error);
            });
        }
        // var url = "https://psmdapi.pspl.co.th/CSRIGHT/SubMenu2?api_key=JmeD3lEvTKVOp0pKPJwHsbGKGDAdZlo5cwbrhsYc";
        // url += "&jwt=" + localStorage.getItem('Token')
        // url += "&user=" + localStorage.getItem('Username') + "&syscode=" + this.state.sysCode;
    }
    render() {
        var rightmenu = ""
        if (this.state.RightMenu) {
            rightmenu = this.state.RightMenu.map(function (RightMenus, i) { return <SubMenu key={i} Name={RightMenus.MENUNAME} sysCode={RightMenus.MENUID} /> })
        }
        return (
            <div >
                {this.state.class === "far fa-minus-square" ?
                    <a href={lineTo(this.state.sysCode)} >
                        <button className="sliderMenuButton2">
                            <i className={this.state.class} title={this.state.sysCode}></i>
                            <i className="C_MenuTxt"> {this.state.manuName}</i>
                            <i id={this.state.sysCode + "loading"}></i>
                        </button>
                    </a>
                    :
                    <div>
                        <button className="sliderMenuButton2" id={this.state.sysCode} title={this.state.sysCode} onClick={this.onActive.bind(null, "menu2")}>
                            <i ref="menu2Icon" className={this.state.class} ></i>
                            <i className="C_MenuTxt"> {this.state.manuName}</i>
                            <i id={this.state.sysCode + "loading"}></i>
                        </button>
                        <div className="sliDivMenu2 active" ref="menu2">
                            {rightmenu}
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export const lineTo = (idmenu) => {
    var link = "";
    switch (idmenu) {
        case "10401": link = "/PSORDERPR"; break; //
        case "10701": link = "/PSPURCHASEORDER____nonActivate"; break; //
        case "10901": link = "/PSPURCHASE"; break; //

        // case "20601": link = "/PSReservationOrder"; break; // บันทึกใบสั่งจองสินค้า
        case "20701": link = "/PSSalesOrder"; break; //บันทึกใบสั่งขาย/สั่งจัดสินค้า
        case "20801": link = "/PSSaleAndService"; break; //บันทึกขายสินค้า/บริการ
        case "20901": link = "/PSReturnProduct"; break; //บันทึกใบขอรับคืนสินค้า

        case "40101": link = "/Savecustomer"; break; //บันทึกข้อมูลลูกค้า
        case "40201": link = "/PSARDeposit"; break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ
        case "40301": link = "/PSARCNDeposit"; break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ

        case "40601": link = "/PSPaybill"; break; // บันทึกใบวางบิล

        case "40801": link = "/PSReceipt"; break; // ตัดบัญชีลูกหนี้/รับชำระ

        case "50101": link = "/Inventory"; break; //บันทึกข้อสินค้า
        case "50301": link = "/CSWithdrawalrequest"; break; // บันทึกใบขอเบิก
        case "50401": link = "/CSProductbring"; break; // บันทึกใบขอเบิก

        case "50801": link = "/PSSaveAskTransfer"; break; //บันทึกใบขอรับคืนสินค้า
        case "50803": link = "/PSSaveTransfer"; break; //บันทึกใบขอรับคืนสินค้า 

        case "60504": link = "/PSCsbankcashin"; break; // บันทึกฝากเงินสด

        case "80901": link = "/PSExpenses"; break; //บันทึกค่าใฃ้จ่ายอื่นๆ
        case "81001": link = "/PSOtherBad"; break; //บันทึกรายได้อื่นๆ

        case "A0630": link = "/PSCC_SaleOrder"; break; //ปิดใบสั่งขาย

        default: link = "/home";
    }
    if (window.location.pathname === link && document.getElementById(idmenu + "loading")) {
        document.getElementById(idmenu + "loading").innerHTML = '<i class="fas fa-anchor"></i>';
    } else if (document.getElementById(idmenu + "loading")) {
        document.getElementById(idmenu + "loading").innerHTML = '';
    }
    return link;
}

export const OnSeeMenu = async (value) => {
    if (localStorage.getItem("Leftmenu")) {
        var list = localStorage.getItem("Leftmenu");
        list = list.split("|");
        list = Array.from(new Set(list));
        for (var i = 1; i < list.length; i++) {
            if (document.getElementById(list[i])) {
                await document.getElementById(list[i]).click();
                //  list.splice( list.indexOf('foo'), 1 );
            }
        }
    }
}